import { Contact } from '../components';

export default (props) => {
    return (
        <Contact.MainSection />
    )
}